"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _request = _interopRequireDefault(require("../../request"));
// 产品管理模块
var _default = exports.default = {
  chatBotQuestion: function chatBotQuestion(data) {
    var demo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var cancelToken = arguments.length > 2 ? arguments[2] : undefined;
    return (0, _request.default)({
      module: 'CHATBOT',
      url: demo ? '/protected/chat/bot/temp/question' : '/protected/chat/bot/question',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  chatBotQuestionRebuild: function chatBotQuestionRebuild(data) {
    var demo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var cancelToken = arguments.length > 2 ? arguments[2] : undefined;
    return (0, _request.default)({
      module: 'CHATBOT',
      url: demo ? '/protected/chat/bot/temp/question/rebuild' : '/protected/chat/bot/question/rebuild',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  chatBotRecommendList: function chatBotRecommendList(data) {
    var demo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var cancelToken = arguments.length > 2 ? arguments[2] : undefined;
    return (0, _request.default)({
      module: 'CHATBOT',
      url: demo ? '/protected/chat/bot/temp/recommend/list' : '/protected/chat/bot/recommend/list',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  chatBotFeedBack: function chatBotFeedBack(data) {
    var demo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var cancelToken = arguments.length > 2 ? arguments[2] : undefined;
    return (0, _request.default)({
      module: 'CHATBOT',
      url: demo ? '/protected/chat/bot/temp/feed/back' : '/protected/chat/bot/feed/back',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  }
};